<!---------------------------------new ui---------------------------------------------------->

<section class="content-header ">
   
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>KPI Change Request</h1>
    </div>
    </div>
    </section>
    <!--------------loader-------------------------->
    <div *ngIf=loaderShown class="loader">
        
    </div>
    <!----------------------------------------------->
    
    <section class="content">
    
    <div class="card"  *ngIf=tableShown >
    <div class="card-header">
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
        <div class="table-responsive">
    <table class="table table-striped projects text-center">
    <thead>
    <tr>
   

    <th  >
    Employee
    </th>

    <th >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </th>
    <th >
        Vist&nbsp;plan&nbsp;Submitted
    </th>
    <th >
        Visit&nbsp;Plan&nbsp;Approved
    </th>
    <th>
        Rfr&nbsp;Over&nbsp;Due&nbsp;Count
    </th>
    <th>
        Rfr&nbsp;Missed&nbsp;Kpi
    </th>
    <th>
        Rft&nbsp;Over&nbsp;Due&nbsp;Count
    </th>
    <th>
        Rft&nbsp;Missed&nbsp;Kpi
    </th>
    <th>
        Unposted&nbsp;Invoices
    </th>
    <th>
        Hardcopy&nbsp;Not&nbsp;Received&nbsp;Invoices
    </th>
    <th>
        Projection&nbsp;Kpi
    </th>
    <th >
        Employee&nbsp;Attendance&nbsp;Point
    </th>


    <th>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Reason&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </th>

    <th >
    Status
    </th>

   <th>
    
   </th>
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>    
    {{c.employee_name}}
    </a>
    </td>
    
    <td>
    {{DateFormat(c.requested_for_date)}}
    </td>
 
    <td>
        <div *ngIf="c.visitPlanWaitingpoint;else other_content">
            <mat-checkbox checked [disabled]="true" class="mx-4"></mat-checkbox>
        </div>
        <ng-template #other_content> <mat-checkbox  [disabled]="true" class="mx-4"></mat-checkbox></ng-template>
    </td>
 
    <td>
        <div *ngIf="c.visitplanApprovedPoint;else other_content">
            <mat-checkbox checked [disabled]="true" class="mx-4"></mat-checkbox>
        </div>
        <ng-template #other_content> <mat-checkbox  [disabled]="true" class="mx-4"></mat-checkbox></ng-template>
     
    </td>
 
    <td>
        <div *ngIf="c.rfr_over_due_count;else other_content">
            <mat-checkbox checked [disabled]="true"></mat-checkbox>
        </div>
        <ng-template #other_content> <mat-checkbox  [disabled]="true"></mat-checkbox></ng-template>
    </td>
    <td>
        <div *ngIf="c.rfr_missed_kpi_point;else other_content">
            <mat-checkbox checked [disabled]="true"></mat-checkbox>
        </div>
        <ng-template #other_content> <mat-checkbox  [disabled]="true"></mat-checkbox></ng-template>
    </td>
    <td>
        <div *ngIf="c.rft_over_due_count;else other_content">
            <mat-checkbox checked [disabled]="true"></mat-checkbox>
        </div>
        <ng-template #other_content> <mat-checkbox  [disabled]="true"></mat-checkbox></ng-template>
    </td>
    <td>
        <div *ngIf="c.rft_missed_kpi_point;else other_content">
            <mat-checkbox checked [disabled]="true"></mat-checkbox>
        </div>
        <ng-template #other_content> <mat-checkbox  [disabled]="true"></mat-checkbox></ng-template>
    </td>
    <td>
        <div *ngIf="c.Unposted_invoices;else other_content">
            <mat-checkbox checked [disabled]="true"></mat-checkbox>
        </div>
        <ng-template #other_content> <mat-checkbox  [disabled]="true"></mat-checkbox></ng-template>
    </td>
    <td>
        <div *ngIf="c.hardcopy_not_received_invoices;else other_content">
            <mat-checkbox checked [disabled]="true"></mat-checkbox>
        </div>
        <ng-template #other_content> <mat-checkbox  [disabled]="true"></mat-checkbox></ng-template>
    </td>
    <td>
        <div *ngIf="c.projection_kpi_point;else other_content">
            <mat-checkbox checked [disabled]="true"></mat-checkbox>
        </div>
        <ng-template #other_content> <mat-checkbox  [disabled]="true"></mat-checkbox></ng-template>
    </td>
    <td>
        <div *ngIf="c.employee_attendance_point;else other_content">
            <mat-checkbox checked [disabled]="true" class="mx-4"></mat-checkbox>
        </div>
        <ng-template #other_content> <mat-checkbox  [disabled]="true" class="mx-4"></mat-checkbox></ng-template>
    </td>
 
    
    <!-- <td>
    {{c.machine_name}}
    </td> -->
    
    <td>
    {{c.reason}}
    </td>
    <td>
    {{c.status}}
    </td>

    <!-- <td *ngIf="c.approve">
     Approved
    </td>

    <td *ngIf="!c.approve">
    Pending
    </td> -->
    
    
    <td class="project-actions text-right">
    <button [disabled]="c.status != 'Requested'" class="btn btn-primary btn-sm" (click)="updateStatus(c._id,1);" >
    <i class="fas fa-award">&nbsp;Approve
    </i>
    
    </button>
    <button [disabled]="c.status != 'Requested'" class="btn btn-danger btn-sm left mt-1" style="padding-left: 13px;" (click)="updateStatus(c._id,2);" >
    <i class="fas fa-trash">
        &nbsp;Reject
    </i>
    </button>
    </td>
    </tr>
    

    </tbody>
    </table>
</div>
    </div>
    
    </div>
    
    </section>
    <!---------------------paging------------------------------------->
<ul class="pagination" *ngIf=tableShown>
    <li class="paginate_button page-item previous" id="example2_previous">
    <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link count">Previous</a></li>
    
    <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link count">{{ New_count+1}}</a></li>
               
    <li class="paginate_button page-item next" id="example2_next" >
    <a  (click)="clicks_next()"  aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
    </ul>
      

    

